import React, { Component, ReactNode, ErrorInfo } from 'react'
import MixusError from '@/app/error'

interface ErrorBoundaryProps {
  children: ReactNode
  fallback: ReactNode
  userId: string
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    // Define a state variable to track whether is an error or not
    this.state = {
      hasError: false
    }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
  }

  render() {
    if (this.state.hasError) {
      <MixusError/>
      return this.props.fallback
    }

    return this.props.children
  }
}

export default ErrorBoundary
